import { render, staticRenderFns } from "./AddUpdateRole.vue?vue&type=template&id=2956c7ef&scoped=true"
import script from "./AddUpdateRole.vue?vue&type=script&lang=js"
export * from "./AddUpdateRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956c7ef",
  null
  
)

export default component.exports